<template>
  <aha-input-group class="relative mb-4">
    <input
      :type="showPassword ? 'text' : 'password'"
      :placeholder="placeholder"
      :class="[`aha-input-${size}`]"
      :required="required"
      :value="value"
      @input="$emit('input', $event.target.value)"
      @keyup="$emit('keyup', $event)"
      class="aha-input"
      ref="input"
      :autocomplete="showPassword ? 'off' : 'new-password'"
    >

    <span
      class="absolute flex items-center cursor-pointer inset-y-2 right-3"
      @click="showPassword = !showPassword"
    >
      <font-awesome-icon
        class="text-base-80"
        :icon="!showPassword ? ['fas', 'eye'] : ['fas', 'eye-slash']"
      />
    </span>
  </aha-input-group>
</template>

<script>
import AhaInputGroup from './InputGroup.vue'

export default {
  components: {
    AhaInputGroup,
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      default: '',
      type: [String, Number],
    },
    type: {
      default: 'text',
      type: String,
    },
    placeholder: {
      default: '',
      type: String,
    },
    required: {
      default: false,
      type: Boolean,
    },
    size: {
      default: 'md',
      type: String,
    },
    maxLength: {
      default: null,
      type: Number,
    },
  },
  data() {
    return {
      showPassword: false,
    }
  },
  computed: {
    showPasswordTooltip() {
      const tooltipText = this.showPassword ? 'Hide password' : 'Show password'
      return tooltipText
    },
  },
}
</script>

<style lang="scss" scoped>
.aha-input__wrapper {
  @apply relative;
}

.aha-input {
  @apply appearance-none;
  @apply pl-2 pr-9 h-10 text-sm rounded w-full border border-secondary-20;
  @apply focus:bg-primary-20 focus:border-primary-90 focus:outline-none;
  @apply hover:bg-primary-20 hover:border-primary-90;
  @apply placeholder-base-70;
}

.aha-input::-webkit-credentials-auto-fill-button {
  @apply invisible;
}

.aha-input-limit {
  @apply pr-9;
}

.aha-input-group>.aha-input__wrapper>.aha-input {
  @apply rounded-l-none;
}

.aha-input-group:hover>.aha-input__wrapper>.aha-input {
  @apply border-primary-90 bg-primary-20;
}

</style>
